export default {
    TAGS: {
        SPORTCAST_BET_BUILDER: "SportcastBetBuilder",
        SGP: "SGP",
    }
};
//# sourceMappingURL=index.js.map